/* AD Automation Theme JS v14 */
(function() {
  'use strict';

  /* --- Mobile Menu ----------------------------------------- */
  const toggle = document.querySelector('[data-mobile-toggle]');
  const menu   = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
      toggle.textContent = open ? '✕' : '☰';
    });
  }

  /* --- Sticky Header Shadow --------------------------------- */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    /* Defer the initial check so it doesn't force a synchronous layout during script execution */
    requestAnimationFrame(onScroll);
  }

  /* --- Back to Top ------------------------------------------ */
  const btt = document.getElementById('BackToTop');
  if (btt) {
    window.addEventListener('scroll', () => {
      btt.classList.toggle('visible', window.scrollY > 500);
    }, { passive: true });
    btt.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  /* --- Spec Tabs -------------------------------------------- */
  document.querySelectorAll('.spec-tabs').forEach(tabBar => {
    const buttons = tabBar.querySelectorAll('button');
    const panels  = tabBar.closest('.specs-table-card').querySelectorAll('.spec-tab-panel');
    buttons.forEach((btn, i) => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('is-active'));
        panels.forEach(p => p.classList.remove('is-active'));
        btn.classList.add('is-active');
        if (panels[i]) panels[i].classList.add('is-active');
      });
    });
    if (buttons[0]) buttons[0].click();
  });

  /* --- Product Image Thumbnails ----------------------------- */
  const mainImg = document.getElementById('ProductMainImage');
  if (mainImg) {
    document.querySelectorAll('.product-detail-main__thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.querySelector('img')?.src;
        if (src) mainImg.src = src;
        document.querySelectorAll('.product-detail-main__thumb').forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  /* --- Quantity Stepper ------------------------------------- */
  document.querySelectorAll('.qty-box').forEach(box => {
    const input = box.querySelector('input');
    box.querySelector('[data-minus]')?.addEventListener('click', () => {
      const v = parseInt(input.value || 1);
      if (v > 1) input.value = v - 1;
    });
    box.querySelector('[data-plus]')?.addEventListener('click', () => {
      input.value = parseInt(input.value || 1) + 1;
    });
  });

  /* --- Smooth Scroll Anchors -------------------------------- */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  /* --- Lazy Load Images ------------------------------------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) { img.src = img.dataset.src; delete img.dataset.src; }
          io.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });
    document.querySelectorAll('img[data-src]').forEach(img => io.observe(img));
  }

  /* --- Contact Form AJAX ------------------------------------ */
  const contactForm = document.getElementById('ContactForm');
  if (contactForm) {
    contactForm.addEventListener('submit', async (e) => {
      const btn = contactForm.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
      // Native Shopify form submission handles this
    });
  }

  /* --- Number format (Shopify money) ------------------------ */
  window.formatMoney = function(cents) {
    const format = window.themeMoneyFormat || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    return format.replace('{{amount}}', amount);
  };

})();
